import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import { RecordResponse } from '../models/ServiceTypes';

export interface AggregatedAccount {
  UpdateDate: string;
  ExternalId: number;
  AggregatorId: number;
  AggregatorName: string;
  FinancialInstitutionId: number;
  InstitutionId: number;
  InstitutionName: string;
  Status: number;
  ErrorMessage: string | null;
  CreateDate: string;
  WealthId: number;
  InvestorId: number;
  Processing: boolean;
  InvestorName: string;
  ProviderUsername: string | null;
  ByAllAdvisorUserName: string;
  NumberOfAccounts: number;
  HasError: boolean;
  HasErrorDisplay: string;
}

export type AggregatedAccountsResponse = RecordResponse<AggregatedAccount>;

export interface ConnectionAttemptActivityModel {
  LogDate: string;
  Description: string;
}

export interface ConnectionAttemptModel {
  LogDate: string;
  Description: string;
  Success: boolean;
  Activity?: ConnectionAttemptActivityModel[];
}

export type AggregatorLogsResponse = RecordResponse<ConnectionAttemptModel>;

export const aggregatedAccountsApi = createApi({
  reducerPath: 'aggregatedAccountsApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    getAggregatedAccountsByInvestor: builder.query<
      AggregatedAccountsResponse,
      {
        investorId: number;
        sortProperty: string;
        sortDirection: 'asc' | 'desc';
        sortOrder: number;
      }
    >({
      query: ({ investorId, sortProperty, sortDirection, sortOrder }) => ({
        url: `/api/administrator/Investors/${investorId}/AggregatedAccounts`,
        params: {
          sort: [
            {
              Property: sortProperty,
              Direction: sortDirection,
              Order: sortOrder,
            },
          ],
          _: new Date().getTime(), // cache busting
        },
      }),
    }),
    getAggregatedAccountLogs: builder.query<AggregatorLogsResponse, number>({
      query: (wealthId: number) => ({
        url: `/api/administrator/Wealths/${wealthId}/AggregatorLogs`,
      }),
    }),
  }),
});

export const {
  useGetAggregatedAccountsByInvestorQuery,
  useGetAggregatedAccountLogsQuery,
} = aggregatedAccountsApi;
